var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgParagraph(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 3.5H12.25C11.6977 3.5 11.25 3.94772 11.25 4.5C11.25 5.05229 11.6977 5.5 12.25 5.5H20.25C20.8023 5.5 21.25 5.05228 21.25 4.5C21.25 3.94772 20.8023 3.5 20.25 3.5ZM21.25 8.5C21.25 7.94771 20.8023 7.5 20.25 7.5H4.25C3.69771 7.5 3.25 7.94772 3.25 8.5C3.25 9.05229 3.69771 9.5 4.25 9.5H20.25C20.8023 9.5 21.25 9.05228 21.25 8.5ZM4.25 11.5H20.25C20.8023 11.5 21.25 11.9477 21.25 12.5C21.25 13.0523 20.8023 13.5 20.25 13.5H4.25C3.69772 13.5 3.25 13.0523 3.25 12.5C3.25 11.9477 3.69772 11.5 4.25 11.5ZM21.25 16.5C21.25 15.9477 20.8023 15.5 20.25 15.5H4.25C3.69771 15.5 3.25 15.9477 3.25 16.5C3.25 17.0523 3.69771 17.5 4.25 17.5H20.25C20.8023 17.5 21.25 17.0523 21.25 16.5ZM14.25 19.5C14.8023 19.5 15.25 19.9477 15.25 20.5C15.25 21.0523 14.8023 21.5 14.25 21.5H4.25C3.69771 21.5 3.25 21.0523 3.25 20.5C3.25 19.9477 3.69771 19.5 4.25 19.5H14.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgParagraph);
export default __webpack_public_path__ + "static/media/paragraph.31b0e2f5533580918b4b5ba6286c92e9.svg";
export { ForwardRef as ReactComponent };